const CurrencyConfig = {
    defaultCurrency: 'GBP',
    defaultLocale: 'en_gb',
    
    defaultCurrencySettings: {
        symbol: ''
    },
    defaultLocaleSettings: {
        template: '$ 1'
    },
    
    currencies: {
        AUD: {
            symbol: '$',
            html: '&dollar;'
        },
        EUR: {
            symbol: '€',
            html: '&euro;'
        },
        GBP: {
            symbol: '£',
            html: '&pound;'
        },
        NZD: {
            symbol: '$',
            html: '&dollar;'
        },
        USD: {
            symbol: '$',
            html: '&dollar;'
        }
    },
    
    locales: {
        de_de: {
            template: '1 $'
        }
    }
}

export default CurrencyConfig;